/* eslint-disable no-undef */
import React, { useState } from 'react';

export default function GenerarEstadisticas() {
    const [statsLoading, setStatsLoading] = useState(false);
    const [statsError, setStatsError] = useState(null);
    const [downloadUrl, setDownloadUrl] = useState(null);

    const handleGenerateStats = async () => {
        const currentYear = new Date().getFullYear();
        const semester = new Date().getMonth() < 6 ? 1 : 2; // enero es mes 0, julio es mes 6
        
        setStatsLoading(true);
        setStatsError(null);
        setDownloadUrl(null);

        const pideEstadisticas = async (data) => {
            const year = data.year;
            const semester = data.semester;
            const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/estadisticas/anos/${year}/semestres/${semester}`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Access-Control-Allow-Credentials': true
                }
            });
            return response;
        };
        
        try {
            const response = await pideEstadisticas({ year: currentYear, semester });
            
            if (!response.ok) {
                throw new Error('Error al generar las estadísticas');
            }
            
            const data = await response.json();
            
            if (data.urlDescarga) {
                setDownloadUrl(data.urlDescarga);
                // Trigger download automatically
                const link = document.createElement('a');
                link.href = data.urlDescarga;
                link.download = `estadisticas_${currentYear}_S${semester}.csv`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } catch (error) {
            setStatsError(error.message);
        } finally {
            setStatsLoading(false);
        }
    };

    return (
        <>
            <button onClick={handleGenerateStats} disabled={statsLoading}>
                {statsLoading ? 'Generando estadísticas...' : 'Generar estadísticas del semestre'}
            </button>
            {statsError && <p style={{ color: 'red' }}>Error: {statsError}</p>}
            {downloadUrl && <p style={{ color: 'green' }}>Archivo descargado correctamente. <a href={downloadUrl} download>Descargar nuevamente</a></p>}
        </>
    );
}
